var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTestFail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F75676",
    fillRule: "nonzero",
    d: "M8.923 8.58H7.608V5.95h1.315m0 5.259H7.608V9.894h1.315m-6.5 3.287h11.686c.442 0 .8-.358.8-.8 0-.14-.037-.279-.107-.4L8.958 1.886c-.221-.383-.71-.513-1.093-.292-.121.07-.222.17-.292.292L1.73 11.98c-.222.383-.091.872.291 1.093.122.07.26.108.401.108z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTestFail);
export default __webpack_public_path__ + "static/media/icon_test_fail.43517e20e63fca27743599fe0a8d60a1.svg";
export { ForwardRef as ReactComponent };